import EventEmitter from "eventemitter3";
import { createContext, ReactNode, useContext, useState } from "react";

export type AppDataStoreEntries = {
  chatHistory: Record<string, string>[];
  visualEvents: EventEmitter
}

export type AppDataStoreType = AppDataStoreEntries & {
  updateStore(values: Partial<AppDataStoreEntries>): void
}

export const DefaultAppDataStore: AppDataStoreType = {
  chatHistory: [],
  updateStore() { },
  visualEvents: new EventEmitter(),
}

export const AppDataStore = createContext(DefaultAppDataStore)

export const AppDataStoreProvider = ({ children }: { children: ReactNode }) => {
  const [store, setStore] = useState(DefaultAppDataStore)

  function updateStore(values: Partial<AppDataStoreEntries>) {
    setStore(p => ({ ...p, ...values }))
  }

  return (
    <AppDataStore.Provider value={{ ...store, updateStore }}>
      {children}
    </AppDataStore.Provider>
  )
}

export const useAppDataStore = () => useContext(AppDataStore)
